import React from "react";
import { useGlobalContext } from "../../utils/globalContext";
import { useMediaQuery } from "react-responsive";
import SectionHeading from "./sectionHeading";
import { Button } from "@speedoc/design-assets";
import VaccinesTable from "./vaccinesTable";
import ContainerCard from "./containerCard";

const TableSection = ({ content }) => {
  const { Trans } = useGlobalContext();
  const isMobile = useMediaQuery({ query: "(max-width: 576px)" });
  return (
    <div id="tableSection">
      <div className="tableHeading">
        <div className="link">
          {content.sectionSubtitle}
          <a
            target="tab"
            href={content.sectionSubtitleLink}
            dangerouslySetInnerHTML={{ __html: content.sectionSubtitleLinkText }}
          />
        </div>
        <SectionHeading title={content.sectionTitle} />
      </div>
      <ContainerCard>
        <div className="intro">
          <div className="title">{content.title}</div>
          <Trans>
            <div className="subtitle" dangerouslySetInnerHTML={{ __html: content.subtitle }} />
          </Trans>
        </div>
        <VaccinesTable content={isMobile ? content.tableMobile : content.table} />

        <div className="bottom">
          <div className="title">{content.bottomTitle}</div>
          <div className="mid-row">
            <div className="price-info">
              {content.bottomInfo.map((info, i) => (
                <Trans key={i}>
                  <div className="group">
                    <div className="name">{info.title}</div>
                    <div className="content">
                      <span className="currency">{info.text.substr(0, 2)}</span>
                      {info.text.substring(2)}
                    </div>
                  </div>
                </Trans>
              ))}
            </div>

            <div className="button-group">
              {isMobile && <div className="description">{content.bottomDescription}</div>}
              <div className="info">{content.buttonInfo}</div>

              <div className="button">
                <Button type="button" className="primary sm">
                  <span>{content.buttonText}</span>
                </Button>
              </div>
            </div>
          </div>
          {!isMobile && <div className="description">{content.bottomDescription}</div>}
        </div>
      </ContainerCard>
    </div>
  );
};

export default TableSection;
